const newYorkData = {
  heroTitle: "New York SEO Company That Drives Real Growth",
  heroDesc:
    "We help New York businesses dominate search rankings, generate qualified traffic, and convert visitors into customers.",

  introTitle: "Leading SEO Agency in New York",
  introDesc1:
    "New York is one of the most competitive markets in the world. Ranking on Google requires precision, authority, and strategy.",
  introDesc2:
    "We create customized SEO campaigns that help businesses in NYC scale sustainably and profitably.",

  benefits: [
    "Increase organic traffic",
    "Rank for high-intent keywords",
    "Generate qualified leads",
    "Improve conversions",
    "Build brand authority",
  ],

  servicesTitle: "Our New York SEO Services",
  services: [
    { title: "Technical SEO", desc: "Fix site issues and boost performance." },
    { title: "On-Page SEO", desc: "Optimize content and keywords." },
    { title: "Local SEO", desc: "Rank in NYC local searches." },
    { title: "Link Building", desc: "Build authority with backlinks." },
    { title: "Content Marketing", desc: "Drive traffic with content." },
    { title: "SEO Audits", desc: "Identify growth opportunities." },
  ],

  whyTitle: "Why Choose Us in New York?",
  whyPoints: [
    "Proven SEO results",
    "Transparent reporting",
    "Custom strategies",
    "Dedicated experts",
    "ROI-focused execution",
  ],

  resultsTitle: "Expected Results",
  results: [
    "📈 2x–5x traffic growth",
    "📍 Higher rankings",
    "💰 Increased revenue",
    "🎯 Better leads",
  ],

  processTitle: "Our SEO Process",
  process: [
    "Audit & Research",
    "Strategy Planning",
    "Implementation",
    "Scaling",
  ],

  ctaTitle: "Ready to Dominate New York Search?",
  ctaDesc:
    "Let’s build a powerful SEO strategy tailored to your business.",

  faqs: [
    {
      q: "How long does SEO take?",
      a: "Usually 3–6 months depending on competition.",
    },
    {
      q: "Do you offer local SEO?",
      a: "Yes, we specialize in NYC local rankings.",
    },
  ],
};

export default newYorkData;